import React, { useRef } from "react";
import ConditionalEndIcon from "../../../../assets/SideBar/ConditionalEndIcon";
import ConditionalStartIcon from "../../../../assets/SideBar/ConditionalStartIcon";
import {
  Container,
  Title,
  Draggable,
  ConditionalNode,
  IconDiv,
} from "./styles";
import { HiddenElements, HiddenIconDiv } from "../Activities/styles";

const Conditionals = ({ Label, onDrag }) => {
  const conditionalIconRef = useRef(null);
  const conditionalEndIconRef = useRef(null);

  return (
    <Container>
      <Title>{Label}</Title>
      <Draggable>
        <ConditionalNode
          style={{ marginRight: "0.125rem" }}
          draggable
          onDragStart={(event) => {
            onDrag(event, "conditional");
            if (conditionalIconRef.current) {
              event.dataTransfer.setDragImage(
                conditionalIconRef.current,
                -15,
                -15
              );
            }
          }}
        >
          <IconDiv>
            <ConditionalStartIcon />
          </IconDiv>
          <span>Início</span>
        </ConditionalNode>
        <ConditionalNode
          draggable
          onDragStart={(event) => {
            onDrag(event, "conditionalEnd");
            if (conditionalEndIconRef.current) {
              event.dataTransfer.setDragImage(
                conditionalEndIconRef.current,
                -15,
                -15
              );
            }
          }}
        >
          <IconDiv>
            <ConditionalEndIcon />
          </IconDiv>
          <span>Fim</span>
        </ConditionalNode>
        <HiddenElements>
          <HiddenIconDiv ref={conditionalIconRef}>
            <ConditionalStartIcon />
          </HiddenIconDiv>
          <HiddenIconDiv ref={conditionalEndIconRef}>
            <ConditionalEndIcon />
          </HiddenIconDiv>
        </HiddenElements>
      </Draggable>
    </Container>
  );
};

export default Conditionals;
